import type { FlowScreenConfig } from "@/shared/constants/flowTypes";

import { ExecutorAllDeclineScreen } from "../components/ExecutorAllDeclineScreen";
import { ExecutorStatusScreen } from "../components/ExecutorStatusScreen";
import { SelfProvingWitnessScreen } from "../components/SelfProvingWitnessScreen";
import { SelfProvingConfirmedScreen } from "../components/SelfProvingConfirmedScreen";
import { WitnessStatementInfoScreen } from "../components/WitnessStatementInfoScreen";
import { WitnessUnavailableInfoScreen } from "../components/WitnessUnavailableInfoScreen";

function hasExecutorAvailable(answers: Record<string, string | string[]>): boolean {
  return (
    answers["executor_status"] === "able_and_willing" ||
    answers["successor_executor"] === "successor_willing"
  );
}

export function createExecutorWitnessesScreens(): FlowScreenConfig[] {
  return [
    {
      id: "executor_status",
      layout: "full",
      customComponent: ExecutorStatusScreen,
      validate: (answers): Record<string, string> => {
        if (!answers["executor_status"]) return { executor_status: "Select an option" };
        if (answers["executor_status"] === "unable" && !answers["successor_executor"]) {
          return { successor_executor: "Select an option" };
        }
        return {};
      },
    },
    {
      id: "executor_all_decline_info",
      layout: "full",
      customComponent: ExecutorAllDeclineScreen,
      shouldDisplay: ({ answers }) =>
        answers["executor_status"] === "unable" &&
        answers["successor_executor"] === "all_decline",
    },
    {
      id: "self_proving_affidavit",
      layout: "full",
      customComponent: SelfProvingWitnessScreen,
      validate: (answers): Record<string, string> => {
        if (!answers["self_proving_affidavit"]) return { self_proving_affidavit: "Select an option" };
        if (answers["self_proving_affidavit"] === "no_or_unsure" && !answers["witness_status"]) {
          return { witness_status: "Select an option" };
        }
        return {};
      },
      shouldDisplay: ({ answers }) => hasExecutorAvailable(answers),
    },
    {
      id: "self_proving_confirmed",
      layout: "full",
      customComponent: SelfProvingConfirmedScreen,
      shouldDisplay: ({ answers }) =>
        hasExecutorAvailable(answers) &&
        answers["self_proving_affidavit"] === "yes",
    },
    {
      id: "witness_statement_info",
      layout: "full",
      customComponent: WitnessStatementInfoScreen,
      shouldDisplay: ({ answers }) =>
        hasExecutorAvailable(answers) &&
        answers["self_proving_affidavit"] === "no_or_unsure" &&
        answers["witness_status"] === "can_sign",
    },
    {
      id: "witness_unavailable_info",
      layout: "full",
      customComponent: WitnessUnavailableInfoScreen,
      shouldDisplay: ({ answers }) =>
        hasExecutorAvailable(answers) &&
        answers["self_proving_affidavit"] === "no_or_unsure" &&
        answers["witness_status"] === "unavailable",
    },
  ];
}
